import React from "react";

import ArrowIcon from "@/assets/icons/arrow-icon-grey.svg";
import Div100vh from "react-div-100vh";
import ByeUserImg from "@/assets/images/bye-user-img.svg";
import DialogBox from "../common/Dialog/dialog";
import GoBackButton from "../common/buttons/GoBackButton";

export default function ByeUserScreen() {
  const [open, setOpen] = React.useState(false);

  return (
    <Div100vh className="flex flex-col px-8 py-8 space-y-1 gap-4 ">
      <GoBackButton />
      <div className="flex flex-col justify-center items-center">
        <img className="max-h-24" src={ByeUserImg} alt="bye-user" />
      </div>
      <div className="flex flex-col gap-4">
        <span className="text-3xl">Sorry To See You Go</span>
        <span className="text-[#9d9d9d] text-lg">
          We had a great time together
        </span>
      </div>
      <div className="flex flex-col">
        <div className="text-lg text-primary-100">
          Before you go, please read below disclamer
        </div>
        <div className="flex flex-col gap-4 mt-5">
          <span className="text-[#9d9d9d] text-xs">
            "Deleting your account means all your data and activity will be
            lost, your any pending rent will be deducted directly from your bank
            account and you can't claim any rewards from CirclePe or CIRCLEPE
            PRIVATE LIMITED."
          </span>
          <span className="text-[#9d9d9d] text-xs">
            To continue deleting please click on the below button and confirm
            your action.
          </span>
        </div>
      </div>
      <div className="mt-2">
        <button
          onClick={() => setOpen(true)}
          className="p-4 text-[#9d9d9d] text-lg flex gap-2 border w-fit justify-between items-center z-10 border-[#9d9d9d]"
        >
          <span>Delete my data</span>
          <img src={ArrowIcon} alt="" className="fill-current text-[#9d9d9d]" />
        </button>
      </div>

      <DialogBox open={open} setOpen={setOpen} />
    </Div100vh>
  );
}
